import * as CookieConsent from 'vanilla-cookieconsent';

export const getCookieConsentConfiguration = (
  baseOrigin: string,
): CookieConsent.CookieConsentConfig => ({
  cookie: {
    name: 'cc_cookie',
  },
  guiOptions: {
    consentModal: {
      layout: 'cloud inline',
      position: 'bottom center',
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: 'box',
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    analytics: {
      services: {
        ga: {
          label: 'Google Analytics',
        },
      },
    },
    ads: {
      services: {
        gcid: {
          label: 'Google Ads',
        },
      },
    },
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'We Value Your Privacy',
          description:
            'We use cookies to enhance your browsing experience, provide personalized ads, and analyze our traffic. Please consent to our use of cookies.',
          acceptAllBtn: 'Accept All',
          acceptNecessaryBtn: 'Reject All',
          showPreferencesBtn: 'Manage Preferences',
          footer: `<a href="${baseOrigin}/privacy-policy" target="_blank">Privacy Policy</a>`,
        },
        preferencesModal: {
          title: 'Manage Cookie Preferences',
          acceptAllBtn: 'Accept All',
          acceptNecessaryBtn: 'Reject All',
          savePreferencesBtn: 'Save Preferences',
          closeIconLabel: 'Close Modal',
          serviceCounterLabel: 'Service|Services',
          sections: [
            {
              title: 'Your Privacy Choices',
              description:
                'You can manage your cookie preferences here. Adjust the toggles to control which cookies you allow.',
            },
            {
              title: 'Analytics',
              description:
                'These cookies help us understand how you use our website, allowing us to improve your experience. All data is anonymized.',
              linkedCategory: 'analytics',
            },
            {
              title: 'Marketing',
              description:
                'These cookies are used to deliver ads more relevant to you and your interests.',
              linkedCategory: 'ads',
            },
          ],
        },
      },
    },
  },
});
